module.exports = __webpack_public_path__ + "static/truebuddy-06261d925ad9f44cf7973036911fd45f.png";